<table class="table table-bordered overflow-scroll">
  <thead>
  <tr>
    <th scope="col">Prestations</th>
    <th *ngIf="displayRegime" scope="col">Régimes</th>
    <th *ngFor="let col of cols" scope="col">{{col | date:'EEE d LLL'}}</th>
  </tr>
  </thead>
  <tbody *ngFor="let item of prestations">
  <tr class="input-saisie-effectifs ">
    <td>{{item.prestation.libelle}}</td>
    <td *ngIf="displayRegime">{{showRegime(item)}}</td>
    <ng-container *ngFor="let col of cols">
      <ng-container *ngTemplateOutlet="tplCell;context:{cell:getEffectif(col, item.rows)}"></ng-container>
    </ng-container>
  </tr>
  </tbody>
</table>

<ng-template #tplCell let-cell="cell">

  <ng-container *ngIf="!utils.isNullOrEmpty(cell)">
    <td [style.width.px]="colWidth"
        [class.cell-invoice]="cell.cmcrPlcDate && cell.cmcrPlcDate.ligneFacturationId !== 0"
        [class.cell-saisie-effectifs]="showStatutMode(cell) === STATUTS_MENUS.SAISIE_EFFECTIFS && !isCellSelected(cell) && cell?.cmcrPlcDate?.ligneFacturationId === 0"
        [class.cell-creation-menus]="showStatutMode(cell) === STATUTS_MENUS.CREATION_MENUS && !isCellSelected(cell) && cell?.cmcrPlcDate?.ligneFacturationId !== 0"
        [class.cell-selected]="isCellSelected(cell)"
        [class.cell-import-effectifs]="!isCellSelected(cell) && cell?.gcomCmcrPlcDate?.id > 0 && hasImportEffectif(cell, typeEffectif)"
        class=" cursor text-right" (click)="showRepas(cell)">

      <ng-container [ngSwitch]="typeEffectif">

        <ng-container *ngSwitchCase="TypeEffectifEnum.PREVISIONNEL">
          <input [class.disable]="isEffectifInputDisabled(cell)"
                 type="text"
                 min="0"
                 step="1"
                 (keydown)="keyDown($event)"
                 [id]="cell?.cmcrPlcDate ? cell?.cmcrPlcDate?.id : cell?.gcomCmcrPlcDate?.id"
                 [hidden]="+cell?.gcomCmcrPlcDate?.id"
                 [readOnly]="!canModifyEffectif(cell)"
                 (focusin)="showRepas(cell)"
                 [ngModel]="cell.effectifPrevisionnel"
                 (ngModelChange)="changeEffectif($event, cell)"
                 (click)="$event.stopPropagation()"
                 class="cell text-right bold">
        </ng-container>

        <ng-container *ngSwitchCase="TypeEffectifEnum.FABRICATION">
          <input [class.disable]="isEffectifInputDisabled(cell)"
                 type="text"
                 min="0"
                 step="1"
                 (keydown)="keyDown($event)"
                 [id]="cell?.cmcrPlcDate ? cell?.cmcrPlcDate?.id : cell?.gcomCmcrPlcDate?.id"
                 [hidden]="+cell?.gcomCmcrPlcDate?.id"
                 [readOnly]="!canModifyEffectif(cell)"
                 (focusin)="showRepas(cell)"
                 [ngModel]="cell.effectifFabrication"
                 (ngModelChange)="changeEffectif($event, cell)"
                 (click)="$event.stopPropagation()"
                 class=" cell text-right bold">
        </ng-container>

        <ng-container *ngSwitchCase="TypeEffectifEnum.FACTURATION">
          <input type="text"
                 min="0"
                 step="1"
                 (keydown)="keyDown($event)"
                 [id]="cell?.cmcrPlcDate ? cell?.cmcrPlcDate?.id : cell?.gcomCmcrPlcDate?.id"
                 [hidden]="+cell?.gcomCmcrPlcDate?.id"
                 [readOnly]="!canModifyEffectif(cell)"
                 (focusin)="showRepas(cell)"
                 [class.disable]="isEffectifInputDisabled(cell)"
                 [ngModel]="cell.effectifFacturation"
                 (click)="$event.stopPropagation()"
                 (ngModelChange)="changeEffectif($event, cell)"
                 class=" cell text-right bold">
        </ng-container>

      </ng-container>
    </td>
  </ng-container>

  <ng-container *ngIf="utils.isNullOrEmpty(cell)">
    <td [class.cell-selected]="false">
      <span>&nbsp;</span>
    </td>
  </ng-container>

</ng-template>
